import React from 'react'

export default function ScrollUp() {
  return (
    <div className='fixed right-0 bottom-0 m-4 w-fit h-fit rounded-full bg-slate-700/50 backdrop-blur-lg flex items-center justify-center hover:animate-bounce'>
        <a href='/' className='w-8 h-8 m-auto text-center justify-self-center flex items-center justify-center text-white font-extrabold cursor-pointer'>&uarr;</a>
    </div>
  )
}
